import React, { useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import { GerenciadorPrecos } from '../../../../../../@types/GerenciadorPrecos';
import { RootState } from '../../../../../../@types/RootState';
import { ContextMenuItem, ContextMenuSeparator } from '../../../../../../components';
import { selectorContextMenu } from '../../../../../../reducers/gerenciadorPrecos/contextMenu';
import { setOptimizationSummaryRowData } from '../../../../../../reducers/gerenciadorPrecos/optimizationPriceEdited';
import { IAComponent } from '../../../../OtimizacaoPrecos/Pages/OtimizacaoPrecos/components/CoordinateSection/ia';
import styles from './OptimizationContextMenu.module.scss';

type OptimizationContextMenuProps = ReturnType<typeof mapStateToProps>;

type RowData = GerenciadorPrecos.RowData;

const OptimizationContextMenu = ({ contextMenuDatapoint }: OptimizationContextMenuProps) => {
  const dispatch = useDispatch();
  const handleOptimizationSummary = useCallback(
    (rowData: RowData) => {
      dispatch(setOptimizationSummaryRowData(rowData));
    },
    [dispatch],
  );

  return (
    contextMenuDatapoint?.priceStatus &&
    ['OTIMIZADO'].includes(contextMenuDatapoint?.priceStatus ?? '') && (
      <>
        <ContextMenuItem className={styles['menu-item-optimization-result']} onClick={() => handleOptimizationSummary(contextMenuDatapoint)}>
          <span>Otimização aplicada ao produto</span>
          <IAComponent />
        </ContextMenuItem>
        <ContextMenuSeparator />
      </>
    )
  );
};

const mapStateToProps = (state: RootState) => ({
  contextMenuDatapoint: selectorContextMenu(state),
});

export default connect(mapStateToProps)(OptimizationContextMenu);
